import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

const List = ({ groceries, deleteItem, editItem }) => {
  return (
    <div className="grocery-list">
      {groceries.map((item, index) => {
        return (
          <article className="grocery-item" key={index}>
            <h4 className="title">{item}</h4>
            <div className="btn-container">
              <button type="button" className="edit-btn" onClick={() => editItem(item, index)}>
                <FaEdit></FaEdit>
              </button>
              <button className="delete-btn" onClick={() => deleteItem(index)}>
                <FaTrash></FaTrash>
              </button>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default List;
